import { useAuthStore } from '../../../context/AuthContext';
import { useStowageStore } from 'src/context/StowageContext';
import { createEmpyStowagePlan, TITLE_MAX_LENGTH } from 'src/factory/Stowage/StowagePlanFactory';
import useStowageQueryParamsUtils from 'src/utils/stowage/useStowageQueryParamsUtils';
import usePostStowageApi from 'src/api/stowage/usePostStowageApi';
import { useEffect, useState } from 'react';
import OdfjellInputComponent from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';

const PageHeaderStowageCopy = () => {
    const { activeStowagePlan, setIsCopyStowagePlanMenuOpen } = useStowageStore();
    const { loggedInUser } = useAuthStore();
    const { setQueryParamStowagePlan } = useStowageQueryParamsUtils();
    const { addStowagePlan } = usePostStowageApi();
    const [newTitle, setNewTitle] = useState<string>('');
    useEffect(() => {
        const _baseTitle = activeStowagePlan.title;
        let _newTitle = '';

        if (_baseTitle.startsWith('Copy of ')) {
            const _copyNumberMatch = _baseTitle.match(/Copy of .+?(\(\d+\))?$/);
            const _currentNumber = _copyNumberMatch?.[1] ? parseInt(_copyNumberMatch[1].replace(/[()]/g, '')) : 0;
            const _baseTitleWithoutNumber = _baseTitle.replace(/\(\d+\)$/, '').trim();
            _newTitle = `${_baseTitleWithoutNumber} (${_currentNumber + 1})`;
        } else {
            _newTitle = 'Copy of ' + _baseTitle;
        }

        if (_newTitle.length > TITLE_MAX_LENGTH) {
            _newTitle = _newTitle.slice(0, TITLE_MAX_LENGTH);
        }
        setNewTitle(_newTitle);
    }, [activeStowagePlan.title]);

    const onCopyStowagePlan = async () => {
        const _stowagePlan = createEmpyStowagePlan(
            activeStowagePlan.imoNumber,
            loggedInUser.fullName,
            activeStowagePlan.stowagePlanGuid,
            newTitle,
            activeStowagePlan.masterPlanVersion
        );
        const { updatedStowagePlan } = await addStowagePlan(_stowagePlan);

        if (updatedStowagePlan) {
            setQueryParamStowagePlan(updatedStowagePlan.stowagePlanGuid, ['portCallGuid', 'berthCallGuid', 'cargoOperationGuid']);
        }
        setIsCopyStowagePlanMenuOpen(false);
    };

    const onClose = () => {
        setIsCopyStowagePlanMenuOpen(false);
    };

    return (
        <OdfjellPanel
            headerTitle="Copy stowage plan"
            defaultPosition="center"
            panelWidth={PANEL_CONSTANTS.MEDIUM_WIDTH}
            hasCurtain={true}
            preventOutsideClose={true}
            onCancel={onClose}
            onAction={onCopyStowagePlan}
            showCancelButton={true}
        >
            <li className="dd-item">
                <OdfjellInputComponent
                    description="Title"
                    type="text"
                    isReadOnly={false}
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.event.target.value)}
                    maxTextLength={50}
                />
            </li>
        </OdfjellPanel>
    );
};

export default PageHeaderStowageCopy;
